<div class="mb-3">
  <app-field-title [titleInfo]="detailInfo" [formControlObj]="formControlObj">
    <span header>
      <button
        type="button"
        class="btn btn-sm btn-link"
        (click)="toggleShowComment()"
        [disabled]="formControlObj.disabled"
      >
        {{ showComment ? 'Remove Comment' : 'Add Comment' }}
      </button>
    </span>

    <div>
      <select
        class="form-select"
        [(ngModel)]="dataStringValue"
        [disabled]="formControlObj.disabled"
        name="selectWithTextModel"
        [required]="detailInfo.isMandatory"
        #selectWithTextModel="ngModel"
        [ngClass]="{
          'ng-touched': selectWithTextModel.touched,
          'ng-dirty': selectWithTextModel.dirty,
          'ng-invalid': selectWithTextModel.invalid,
          'ng-valid': selectWithTextModel.valid
        }"
        (ngModelChange)="selectOption()"
      >
        <option value="">
          {{ isOptionLoading ? 'Loading..' : 'Select Option' }}
        </option>

        <ng-container *ngFor="let group of optionGroups">
          <optgroup *ngIf="group.heading" [label]="group.heading">
            <option
              *ngFor="let option of group.options; trackBy: trackByKey"
              [value]="option.key"
            >
              {{ option.value }}
            </option>
          </optgroup>
          <ng-container *ngIf="!group.heading">
            <option
              *ngFor="let option of group.options; trackBy: trackByKey"
              [value]="option.key"
            >
              {{ option.value }}
            </option>
          </ng-container>
        </ng-container>
      </select>

      <div *ngIf="showComment">
        <textarea
          style="white-space: pre-line"
          #commentBox
          class="form-control mt-2"
          placeholder="Add comment"
          [(ngModel)]="dataStringExtraValue"
          (ngModelChange)="selectOption()"
          [disabled]="formControlObj.disabled"
        ></textarea>
      </div>
    </div>
  </app-field-title>
</div>
